import React from 'react';
import { useTranslation } from 'react-i18next';
import { cmTierSummary, normalizeProgram } from '../../utils/partnersAdmin';

/**
 * Programa del partner (RES-98). En CM suma el escalón actual y cuánto falta para el
 * siguiente, p. ej. "CM · 25% · faltan 2 para 30%".
 */
function PartnerProgramLabel({ program, cmTier, compact = false }) {
  const { t } = useTranslation();
  const normalized = normalizeProgram(program);

  if (normalized === 'influencer') {
    return (
      <span className="program-badge program-influencer" data-program="influencer">
        {t('partners.program.influencerShort', 'Influencer')}
      </span>
    );
  }

  const tier = cmTierSummary(cmTier);
  let tierText = null;
  if (tier) {
    const next =
      tier.nextPct !== null
        ? t('partners.program.cmNext', 'faltan {{count}} para {{pct}}%', {
            count: tier.missing,
            pct: tier.nextPct,
          })
        : t('partners.program.cmTopTier', 'escalón máximo');
    tierText = `${tier.pct}% · ${next}`;
  }

  return (
    <span className="program-cell" data-program="cm">
      <span className="program-badge program-cm">{t('partners.program.cmShort', 'CM')}</span>
      {tierText && (
        <span className={compact ? 'program-tier program-tier--compact' : 'program-tier'}>
          {tierText}
        </span>
      )}
    </span>
  );
}

export default PartnerProgramLabel;
